import type { LiteralUnion } from "type-fest";

export const partners = [
    "aafes",
    "adt",
    "amazon",
    "amazonrouter",
    "armstrongmccall",
    "asurion",
    "asurionhomeplus",
    "asuriontechcare",
    "att",
    "attconnectedhome",
    "backmarket",
    "bjs",
    "blains",
    "bluestream",
    "brightspeed",
    "cactus",
    "cgx",
    "clyde",
    "comcastbusiness",
    "cosmoprof",
    "cox",
    "cricket",
    "dell",
    "dish",
    "dsg",
    "ee",
    "expertuniversity",
    "fieldstream",
    "fingerhut",
    "fios",
    "frontier",
    "gettington",
    "golfgalaxy",
    "guitarcenter",
    "homepro",
    "hotwire",
    "hotwirecommunications",
    "hpsales",
    "jcp",
    "koodo",
    "leakprotect",
    "lgelectronics",
    "liberty",
    "life360",
    "mcafeesecurityscan",
    "mcafeetechsupport",
    "mcx",
    "mediacom",
    "meijer",
    "microsoft",
    "nex",
    "nexcom",
    "nrg",
    "optimum",
    "optimumbiz",
    "others",
    "overstock",
    "paycheckdirect",
    "pilot",
    "quill",
    "reach",
    "sallybeauty",
    "samsung",
    "samsungna",
    "shopko",
    "smartpay",
    "soluto",
    "sparklight",
    "sparklightsales",
    "sprint",
    "staples",
    "stapleshome",
    "staplessmb",
    "telus",
    "telushomepro",
    "thesource",
    "tmobile",
    "tracfone",
    "tsc",
    "unknown",
    "uscellular",
    "vcs",
    "verizon",
    "verizonconnectedhome",
    "verizonwholeoffice",
    "viasat",
    "vip",
    "vzwsmb",
    "xboxcareplus",
    "yahoo",
    "youtubetv",
] as const;
/** known partner or any string */
export type Partner = LiteralUnion<(typeof partners)[number], string>;

/**
 * Converts a partner value from UI display text to the canonical partner **key** expected
 * by APIs and backends: lowercase, with spaces and `&` removed (e.g. how "AT&T" is shown
 * to users vs. the `att` slug sent in requests).
 *
 * @param partner - Label or mixed-case string from the UI (e.g. `"AT&T"`)
 *   or any string to normalize toward the backend form.
 * @returns The normalized key, e.g. `"AT&T"` → `"att"`, `"Verizon"` → `"verizon"`.
 *
 * @example
 * normalizePartnerKeyForApi("AT&T"); // "att"
 */
export function normalizePartnerKeyForApi(partner: string): string {
    return partner.toLowerCase().replace(/&/g, "").replace(/ /g, "");
}
